import { createSlice } from '@reduxjs/toolkit';
import get from 'lodash/get';
import isString from 'lodash/isString';
import { pages as initialState } from '../initialState';
import { buildAsyncReducers } from '../thunkTemplate';
import { navigate, handleWebsocketMessage } from './_pages';

const { reducer, actions } = createSlice({
  name: 'pages',
  initialState,
  reducers: {
    setLoader(state, action) {
      state.loaderOpen = action.payload;
    },
    setWebsocketOrgId(state, action) {
      state.websocket.orgId = action.payload;
    },
    setWebsocketLastUpdate(state, action) {
      state.websocket.lastUpdate = action.payload;
    },
    setPage(state, action) {
      const page = action.payload.page;

      let id = isString(get(action, 'payload.id'))
        ? action.payload.id
        : state[page].id;

      let expectationType = isString(get(action, 'payload.expectationType'))
        ? action.payload.expectationType
        : state[page]?.expectationType;

      state[page] = { id, expectationType };
    },
  },
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [navigate, handleWebsocketMessage]);
  },
});

const { setLoader, setPage, setWebsocketOrgId, setWebsocketLastUpdate } =
  actions;
export {
  setLoader,
  navigate,
  setPage,
  setWebsocketOrgId,
  setWebsocketLastUpdate,
  handleWebsocketMessage,
};
export default reducer;
